
import {defineComponent} from "vue";
import {ToastSnackBarIcon, ToastSnackBarMessage} from "./models/ToastSnackBar";

export default defineComponent({
    name: 'ToastSnackBar',
    props: {
        id: {
            type: String,
            required: false,
            default: undefined
        },
    },
    data() {
        return {
            displayedIcon: undefined as (ToastSnackBarIcon | undefined),
            displayedMessage: "" as string,
        }
    },
    mounted() {
        // Load ob1-snack-bar
        //@ts-ignore
        ob1.Ob1Component.load(this.$el.parentElement);
    },
    methods: {
        showToastSnackBarMessage(toastSnackBarMessage: ToastSnackBarMessage | undefined) {
            if (toastSnackBarMessage) {
                this.displayedIcon = toastSnackBarMessage.icon;
                this.displayedMessage = toastSnackBarMessage.message;

                //@ts-ignore
                const toastSnackBar = ob1.Ob1Component.get(this.$el).Snackbar;
                if (toastSnackBar) {
                    toastSnackBar.startAnimation();
                }
            }
        }
    }
});
